import { render } from "./ReconsentCampaignmodal.vue?vue&type=template&id=07b95f6e&scoped=true"
import script from "./ReconsentCampaignmodal.js?vue&type=script&lang=js"
export * from "./ReconsentCampaignmodal.js?vue&type=script&lang=js"

import "./ReconsentCampaignmodal.vue?vue&type=style&index=0&id=07b95f6e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b95f6e"]])

export default __exports__